import { render } from "./CatalogOverview.vue?vue&type=template&id=7671ca23"
import script from "./CatalogOverview.vue?vue&type=script&lang=js"
export * from "./CatalogOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__